
import React from "react";
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useHistory, useLocation } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress'
import { connect } from 'react-redux';
import axios from 'axios';
import Tooltip from '@material-ui/core/Tooltip';
import { Button, Card, CardHeader, CardBody, Form, Input, InputGroupAddon, InputGroupText, InputGroup, Row, Col,} from "reactstrap";
const Login = (props) => {

    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [vcode, setvcode] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [loading, setloading] = React.useState('Signup');
    const [disabling, setdisabling] = React.useState(false);

    const history = useHistory();
    const location = useLocation();

    if (location) {
        // console.log('yes location')
        // console.log(location);
        // console.log(location.state);
        if (location.state != null) {
            if (location.state.token) {
                if (location.state.token === 1) {
                    // console.log(location.state.message);
                    setSendingdata(location.state.message);
                    settt(location.state.type);
                    setOpen(true);
                    location.state.token -= 1;
                }
            }
        }
        else{
            history.push({
                pathname: '/auth/signup',
                state:{
                    token:1,
                    type:'error',
                    message:'Something went wrong'
                }
            })
        }
    }

    const [details] = React.useState(location.state);
    const [code, setCode] = React.useState();
    // const [website, setCompany] = React.useState();
    const handleChangeU = (event) => {
        if(location.state!==undefined){
            if (event.target.value === location.state.code) {
                setCode('right');
            }
            else {
                setCode('wrong');
            }    
        }
        setvcode(event.target.value)
    };
    // const handleChangeE = (event) => {
    //     setCompany(event.target.value)
    // };

    // const handleChange = (event) => {
    //     setDetails({ ...details, [event.target.name]: event.target.value })
    // };

    // console.log(details)
    // const skiploginPageHandler = () => {
    //     setSendingdata('Please wait a sec')
    //     settt('success')
    //     setOpen(true);
    //     // if (assigned.length < 1) {
    //     //     setSendingdata('Please Enter the person you are assigned')
    //     //     settt('error')
    //     //     setOpen(true);
    //     //     return 0;
    //     // }
    //     if (code === 'right') {
    //         var inp = location.state
    //         console.log(inp)
    //         axios.post(process.env.REACT_APP_DOMAIN+'/signup2', inp)
    //             .then((response) => {
    //                 history.push({
    //                     pathname: '/auth/login',
    //                     state: {
    //                         "token": 1,
    //                         "message": response.data['message'],
    //                         "type": response.data['type']
    //                     }
    //                 })
    //             })
    //     }
    //     else {
    //         setSendingdata('Wrong Verification Code')
    //         settt('error')
    //         setOpen(true);
    //     }
    // };

    const handleClose = (event, reason) => {
        setOpen(false);
    };

    const handleKeypress = e => {
        //it triggers by pressing the enter key
        // console.log(e)
        if (e.keyCode === 13) {
            e.preventDefault()
            loginPageHandler();
        }
    };

    const loginPageHandler = (e) => {
        // console.log("login with details");
        setloading(<CircularProgress size="20px" style={{ color: '#172b4d' }} />)
        setdisabling(true)
        setSendingdata('Please wait a sec')
        settt('success')
        setOpen(true);
        if (code === 'right') {
            // console.log(details)
            axios.post(process.env.REACT_APP_DOMAIN+'/confirm-signup', details)
                .then((response) => {
                    // console.log(response.data)
                    setloading('Signup')
                    setdisabling(false)
                    if(response.data['status']===201){
                        history.push({
                            pathname: '/auth/login',
                            state: {
                                "token": 1,
                                "message": response.data['message'],
                                "type": response.data['type']
                            }
                        })
                    }
                    else {
                        setSendingdata('Something went wrong')
                        settt('error')
                        setOpen(true);
                        setloading('Signup')
                        setdisabling(false)
                    }
                })
                .catch((error) => {
                    setSendingdata('Something went wrong, Please Try Again')
                    settt('error')
                    setOpen(true);
                    setloading('Signup')
                    setdisabling(false)
                })
        }
        else {
            setSendingdata('Wrong Verification Code')
            settt('error')
            setOpen(true);
            setloading('Signup')
            setdisabling(false)
        }
    };


    return (
        <>
            <Col lg="7" md="7">
                <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-transparent pb-5">
                        <div className="btn-wrapper text-center">
                            <Button
                                className="btn-neutral btn-icon"
                                color="default"
                                href="#pablo"
                                onClick={(e) => e.preventDefault()}
                            >
                                <span className="btn-inner--icon">
                                    <img
                                        alt="..."
                                        src={
                                            require("../../assets/img/kj.png")
                                                .default
                                        }
                                    />
                                </span>
                                <span className="btn-inner--text">Details Page</span>
                            </Button>
                        </div>
                    </CardHeader>
                    <CardBody className="px-lg- py-lg-5">
                        <Form role="form">
                            <Row className="row justify-content-center">
                                {/* <h1>You're just one step </h1> */}
                                <Col className="text-center mb-3" sm={12} lg={12}>
                                        <h3>You're only one step behind from signing up!</h3>
                                        <h4 className="no-w mt-4">Enter the  Code sent to your Email</h4>
                                </Col>
                            </Row>
                            <Row className="row justify-content-center mt-3">
                                {/* <h1>You're just one step </h1> */}
                                <Col className="mb-3" sm={12} lg={6}>
                                        <Tooltip title={(code === 'right' ? 'Verification Code is Correct' : 'Enter Code sent to your Email')} arrow>
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                    <InputGroupText style={{ backgroundColor: (code === 'right' ? 'lightgreen' : 'white'), color: (code === 'right' ? 'black' : '')}}>
                                                    <i className="ni ni-key-25" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                maxLength={7}
                                                autoFocus
                                                placeholder="Verification Code"
                                                type="text"
                                                value={vcode}
                                                style={{ backgroundColor: (code === 'right' ? 'lightgreen' : 'white'), color: (code === 'right' ? 'black' : '')}}
                                                autoComplete=""
                                                onChange={handleChangeU}
                                                onKeyDown={handleKeypress}
                                            />
                                        </InputGroup>
                                        </Tooltip>
                                </Col>
                            </Row>
                            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                                <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                            </Snackbar>
                            <div className="text-center mt-3">
                                <Button className="my-2" color="primary" type="button"
                                    onClick={loginPageHandler} disabled={disabling} >
                                    {loading}
                                </Button>
                            </div>
                        </Form>
                    </CardBody>
                </Card>
                <Row className="mt-3">
                    <Col xs="6">
                        <a
                            className="text-light"
                            href="login"
                        >
                            <small>Login</small>
                        </a>
                    </Col>
                    <Col className="text-right" xs="6">
                        <a
                            className="text-light"
                            href="forgot-password"
                            onClick={(e) => e.preventDefault()}
                        >
                            <small>Forgot password?</small>
                        </a>
                    </Col>
                </Row>
            </Col>
        </>
    );
};

// export default Login;

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
    }
}

export default connect(mapStateToProps)(Login);